import { queryOptions } from '@tanstack/react-query'

import { PickupDeliveryLocationListRequestV1 } from '@forto-dev/customer-master-data-models'

import { pickupDeliveryLocationClient } from './pickupDeliveryLocation.service'

export const pickupDeliveryLocationsQueries = {
  all: () => ['pickup-delivery-locations'],
  lists: () => [...pickupDeliveryLocationsQueries.all(), 'list'],
  list: (queryParams: PickupDeliveryLocationListRequestV1) =>
    queryOptions({
      queryKey: [...pickupDeliveryLocationsQueries.lists(), queryParams],
      queryFn: () => pickupDeliveryLocationClient.listPickupDeliveryLocations(queryParams),
    }),
}
